/**
 * Maps a 0–100 score to its band — the mobile equivalent of desktop's
 * `getCommentAndColor` (components/Gauge + PerformanceReview/constants).
 *
 * The band thresholds are desktop's exactly (90 / 70 / 50). The labels follow
 * the mobile Figma ("Good" / "Average" / "Needs Improvement") rather than
 * desktop's wording ("Good" / "Satisfactory" / "Needs improvement"). Colours are
 * lifted from desktop's CommentAndColor palette.
 */
export function getScoreBand(score = 0) {
  const s = Math.round(Number.isFinite(score) ? score : 0);

  if (s >= 90) {
    return { label: "Excellent", ring: "#009970", chipColor: "#00664A", chipBg: "#DCFCE7" };
  }
  if (s >= 70) {
    return { label: "Good", ring: "#009970", chipColor: "#00664A", chipBg: "#DCFCE7" };
  }
  if (s >= 50) {
    return { label: "Average", ring: "#F5B847", chipColor: "#664100", chipBg: "#FFF6E5" };
  }
  return { label: "Needs Improvement", ring: "#E2483C", chipColor: "#C51407", chipBg: "#FFE6E3" };
}

// The gauge arc's three fixed bands (0–50 / 50–70 / 70–100), matching desktop's
// Meter breakpoints. Approximated to the Figma's coral / cream / emerald.
export const GAUGE_SEGMENTS = [
  { from: 0, to: 50, color: "#F5897F" },
  { from: 50, to: 70, color: "#FCEBCB" },
  { from: 70, to: 100, color: "#00A76F" },
];
